import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { Button } from "@/components/ui/button";
import { Plus, X } from "lucide-react";

const OFFSET_OPTIONS = [
  { value: 15, label: "15 minutes before" },
  { value: 30, label: "30 minutes before" },
  { value: 60, label: "1 hour before" },
  { value: 120, label: "2 hours before" },
  { value: 240, label: "4 hours before" },
  { value: 1440, label: "24 hours before" },
  { value: 2880, label: "48 hours before" },
];

export const ReminderScheduleFields = ({ schedule, onChange, testIdPrefix }) => {
  const setOffset = (idx, val) => {
    const next = [...schedule];
    next[idx] = { offsetMinutesBeforeStart: Number(val) };
    onChange(next);
  };
  const addOccurrence = () => onChange([...schedule, { offsetMinutesBeforeStart: 60 }]);
  const removeOccurrence = (idx) => onChange(schedule.filter((_, i) => i !== idx));

  return (
    <div className="space-y-2">
      {schedule.map((occ, idx) => (
        <div key={idx} className="flex items-center gap-2">
          <Select value={String(occ.offsetMinutesBeforeStart)} onValueChange={(v) => setOffset(idx, v)}>
            <SelectTrigger className="h-8 text-xs bg-white" data-testid={`${testIdPrefix}-offset-${idx}`}>
              <SelectValue />
            </SelectTrigger>
            <SelectContent>
              {OFFSET_OPTIONS.map((o) => (
                <SelectItem key={o.value} value={String(o.value)}>{o.label}</SelectItem>
              ))}
            </SelectContent>
          </Select>
          {schedule.length > 1 && (
            <button type="button" onClick={() => removeOccurrence(idx)} data-testid={`${testIdPrefix}-remove-${idx}`}>
              <X className="w-3.5 h-3.5 text-slate-400 hover:text-[#C97B7B]" />
            </button>
          )}
        </div>
      ))}
      {schedule.length < 2 && (
        <Button type="button" variant="ghost" size="sm" onClick={addOccurrence}
          className="h-7 px-2 text-xs text-[#4C8C8C] hover:bg-[#4C8C8C]/10" data-testid={`${testIdPrefix}-add`}>
          <Plus className="w-3 h-3 mr-1" /> Add a second reminder
        </Button>
      )}
    </div>
  );
};
